export type SingleLineTextFieldPublicValue = string;
export type SingleLineTextFieldInternalValue = string | undefined;

export const singleLineTextFieldSetValueValidator = (
	value: unknown,
): value is SingleLineTextFieldPublicValue => typeof value === 'string';

export const singleLineTextFieldGetValueTransformer = (
	internalValue: SingleLineTextFieldInternalValue,
): SingleLineTextFieldPublicValue => (internalValue !== undefined ? internalValue : '');
